import type { AxiosInstance } from 'axios'

import {
  CreateProductInputInterface,
  ProductDetailInterface
} from '../../interfaces/product'

export const createProduct = (api: AxiosInstance) => (
  productDetail: CreateProductInputInterface
): Promise<ProductDetailInterface> =>
  api.post('/v1.0/admin/products', productDetail)
